import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import RedButton from 'components/buttons/RedButton';
import WhiteButton from 'components/buttons/WhiteButton';
import { H4 } from 'components/typography/Headers';
import { Text1 } from 'components/typography/Texts';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled(H4)`
  margin-bottom: 18px;
`;

const Description = styled(Text1)`
  margin-bottom: 36px;
`;

const Button = styled(RedButton)`
  width: 200px;
  margin: 0 12px;
`;

const StyledWhiteButton = styled(WhiteButton)`
  width: 200px;
  margin: 0 12px;
`;

const ButtonsWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

interface Props {
  onFirstButtonClick: () => void;
  onSecondButtonClick?: () => void;
}

const AccountClosingPopup = ({ onFirstButtonClick, onSecondButtonClick }: Props) => {
  const { t } = useTranslation('myProfile');
  return (
    <Container data-testid={'account-closing-popup'}>
      <Header data-testid={'alert-header'}>{t('account-settings.account-closing')}</Header>
      <Description data-testid={'alert-description'}>{t('account-settings.account-closing-desc')}</Description>
      <ButtonsWrapper>
        <StyledWhiteButton data-testid={'alert-first-button'} onClick={onFirstButtonClick}>
          {t('account-settings.confirm')}
        </StyledWhiteButton>

        <Button data-testid={'alert-second-button'} onClick={onSecondButtonClick}>
          {t('account-settings.cancel')}
        </Button>
      </ButtonsWrapper>
    </Container>
  );
};

export default AccountClosingPopup;
